import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';

export interface UserTokenData {
  sub?: string;
  'cognito:username'?: string;
  'cognito:groups'?: string;
  given_name?: string;
  family_name?: string;
  email?: string;
  email_verified?: boolean;
  [key: string]: any;
}

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent implements OnInit {
  isLoggedIn = false;
  mobileMenuOpen = false;
  usernav = '';

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    this.checkUserSession();
    let user:UserTokenData | null;
    user = this.authService.getUserFromToken();
    
    if(user?.['cognito:groups'] && user?.['cognito:groups'].includes('admin-hotel')){
    console.log("USEEEEEEEEEEEER",user?.['cognito:groups']);
    this.usernav='Admin';
    }

    if(user?.['cognito:groups'] && user?.['cognito:groups'].includes('admin-recepcion')){
    console.log("USEEEEEEEEEEEER",user?.['cognito:groups']);
    this.usernav='Recepcion';
    }

  }

  toggleMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  async checkUserSession() {
    try {
      // Primero hacer una verificación local del token
      const hasToken = this.authService.hasValidToken();
      console.log('🔍 Token válido encontrado:', hasToken);
      this.isLoggedIn = hasToken;

      // Solo si hay token válido, intentar verificación completa
      if (hasToken) {
        try {
          const isAuthenticated = await this.authService.isAuthenticated();
          console.log('✅ Autenticación verificada:', isAuthenticated);
          this.isLoggedIn = isAuthenticated;
        } catch (authError) {
          console.warn('⚠️ Error en verificación de autenticación:', authError);
          // Mantener el estado basado en el token local
        }
      }
    } catch (error) {
      console.error('❌ Error checking user session:', error);
      this.isLoggedIn = false;
    }
  }

  async signOut() {
    try {
      await this.authService.signOut();
      this.isLoggedIn = false;
      this.router.navigate(['/loggin']);
    } catch (error) {
      console.error('❌ Error durante logout:', error);
      // Incluso si hay error, limpiar el estado local
      this.isLoggedIn = false;
      this.router.navigate(['/loggin']);
    }
  }
}